export default __webpack_public_path__ + "static/media/img-guide-gt-popup-3-fr_fr.fe5cb037.png";